<script setup lang="ts">
import { onBeforeMount, onUnmounted, ref } from 'vue'
import AccosBar from './components/accosbar/AccosBar.vue'
import EnquiryBar from './components/enquirybar/EnquiryBar.vue'
import EnquiryPage from './components/enquirypage/EnquiryPage.vue'
import FilterPage from './components/filterpage/FilterPage.vue'
import {
  delteLocalStorageIfOldVersion,
  ensureStoresAreFilled,
  garbageCollectBroadcastChannels,
  setGlobalVars,
  setVersionInLocalStorage
} from './composables/helpers'
import { AccosBarName, EnquiryBarName, EnquiryPageName, FilterPageName } from './constants'

const loadingDataDone = ref(false)

const props = defineProps<{
  componentType: string
  l: string
  pid: number
  areaid: number | undefined
  mapkey: string | undefined
  mapid: string | undefined
  cid: number | undefined
  accosListPageFilter: string | undefined
  enablemini: boolean | undefined
  themeid: number | undefined
}>()

setGlobalVars(props.pid, props.l, props.areaid, props.mapkey, props.mapid, props.cid, props.accosListPageFilter, props.enablemini, props.themeid)

delteLocalStorageIfOldVersion()
setVersionInLocalStorage()

const getComponent = (componentType: string) => {
  switch (componentType) {
    case FilterPageName:
      return FilterPage
    case AccosBarName:
      return AccosBar
    case EnquiryBarName:
      return EnquiryBar
    case EnquiryPageName:
      return EnquiryPage
    default:
      throw new Error('wrong component type')
  }
}

const selectedComponent = getComponent(props.componentType)

onBeforeMount(async () => {
  await ensureStoresAreFilled(props.componentType) // must be done in onbeforemount: https://vuejs.org/api/sfc-script-setup#top-level-await - https://vuejs.org/guide/essentials/lifecycle.html
  loadingDataDone.value = true
})
onUnmounted(() => {
  garbageCollectBroadcastChannels()
})
</script>

<template>
  <Suspense>
    <div id="vue-app" v-if="loadingDataDone">
      <component :is="selectedComponent" />
    </div>
  </Suspense>
</template>
